import { render, staticRenderFns } from "./PortfolioNotFound.vue?vue&type=template&id=5f722d17&scoped=true&"
var script = {}
import style0 from "./PortfolioNotFound.vue?vue&type=style&index=0&id=5f722d17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f722d17",
  null
  
)

export default component.exports